import React, { memo, useContext } from 'react';
import { Grid, Paper, withStyles, useMediaQuery, Typography, Divider } from '@material-ui/core';
import { ReactComponent as PilotIcon} from '../../assets/pilot-icon.svg'
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import dayjs from 'dayjs';
import { SessionContextStore } from '../../context/SessionContext/SessionContext';
import { useParams } from 'react-router-dom';

const CustomPaper = withStyles(theme => ({
    root: {
        borderRadius: 10,
        boxShadow: '0 4px 8px 0 rgba(44, 39, 56, 0.04)',
        padding: '15px 15px'
    }
}))(Paper);

const ClickableText = withStyles(theme => ({
    root: {
        fontFamily: 'Poppins-regular',
        textDecoration: 'underline',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}))(Typography);

const InfoText = withStyles(theme => ({
    root: {
        fontFamily: 'Poppins-regular',
        display: 'inline-block',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.85em'
        }
    }
}))(Typography);

const PilotItem = memo(({ pilot, pilotId }) => {
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md')); 
    const { quoteId } = useParams();
    const { setCurrentPilot, deletePilot } = useContext(QuoteContextStore);

    return (
            <CustomPaper elevation={0}>
                <Grid container wrap="nowrap" alignItems="center" direction={isMobile ? 'row-reverse' : 'row'}>
                    <Grid item>
                        <PilotIcon className='pilot-icon'/>
                    </Grid>
                    <Grid item container wrap={isMobile ? 'wrap' : 'nowrap'} alignItems={isMobile ? 'center' : 'flex-start'} justifyContent='space-between' className='margin-right-small'>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-between'>
                                <Grid item>
                                    <InfoText className="bold margin-right-6">First name: </InfoText>
                                    <InfoText>{pilot.first_name}</InfoText>
                                </Grid>
                                {!isMobile && <ClickableText onClick={() => deletePilot(pilotId, quoteId)}>Delete</ClickableText> }
                            </Grid>
                            <Grid>
                                <InfoText className="bold margin-right-6">Last name: </InfoText>
                                <InfoText>{pilot.last_name}</InfoText>
                            </Grid>
                            <Grid>
                                <InfoText className="bold margin-right-6">Date of birth: </InfoText>
                                <InfoText>{dayjs(new Date(pilot.date_of_birth)).format('MM/DD/YYYY')}</InfoText>
                            </Grid>
                            <Grid container justifyContent='space-between'>
                                <Grid item>
                                    <InfoText className="bold margin-right-6">Certification: </InfoText>
                                    <InfoText>{pilot.certification}</InfoText>
                                </Grid>
                                {!isMobile && <ClickableText onClick={() => setCurrentPilot(pilotId, quoteId)}>View / Edit</ClickableText> }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {isMobile &&
                <>
                <Divider />
                <Grid container justifyContent='space-between'>
                                <ClickableText onClick={() => setCurrentPilot(pilotId, quoteId)}>View / Edit</ClickableText>
                                <ClickableText onClick={() => deletePilot(pilotId, quoteId)}>Delete</ClickableText>
                            </Grid>
                </>}
            </CustomPaper>
    );
});

export default PilotItem;
